<script>
    import {createEventDispatcher} from "svelte";
    import {eventBus} from "../core/event-bus-store.js";
    const dispatch = createEventDispatcher();

    export let record;
    export let publishConfig;
    export let tenantKey;
    export let noBottomLine;

    const addToCartHandler = (record) => {
        if (record?.prices?.length > 1 || record?.mods?.length > 1) {
            eventBus.set([{event: 'openEditDetailsHalfScreen', payload: {record, mode: 'addItems'}}]);
        }
        else {
            dispatch('addToCart', record);
        }
    };

    const removeFromCartHandler = (record) => {
        if (record?.prices?.length > 1 || record?.mods?.length > 1) {
            eventBus.set([{event: 'openEditDetailsHalfScreen', payload: {record, mode: 'removeItems'}}]);
        }
        else {
            dispatch('removeFromCart', record);
        }
    };
</script>

<style>

    .record {
        width: 100%;
        padding-top: .5rem;
        padding-bottom: .5rem;
        gap: .4rem;
    }

    .label {
        background: var(--accent);
        text-transform: uppercase;
        font-weight: 200;
        border-radius: 1rem;

        color: var(--label-text);
        line-height: 1;
        padding: 2px 8px;
        font-size: var(--fs-75);
    }
    .name {
        text-transform: uppercase;
        font-size: var(--fs-125);
        font-weight: 400;
        color: var(--primary-text);
        text-align: center;
    }
    .weight {
        font-size: var(--fs-100);
        color: var(--light-text);
        text-transform: none;
    }
    hr {
        height: 1px;
        min-width: 2rem;
        border: none;
        border-bottom: 1px solid var(--accent);
    }
    .description {
        font-weight: 200;
        white-space: pre-wrap;
        color: var(--secondary-text);
        text-align: center;
        line-height: 1.2;
    }
    .price {
        font-size: var(--fs-120);
    }
    .price--old {
        font-size: var(--fs-100);
        color: var(--light-text);
        text-decoration: line-through;
        font-weight: 200;
    }
    .currency {
        font-size: var(--fs-100);
        font-weight: 100;
    }
    .pt-05 {
        padding-top: .5rem;
    }
    .pb-05 {
        padding-bottom: .5rem;
    }
</style>

<div class="record flex-column ai-center full-width">

    <div class="flex ai-center gap-05 full-width pb-05">
        <hr class="flex-fill">
        <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.25752 4.82316e-05C7.67219 0.702715 7.5295 2.19339 8.34017 3.08805C9.64284 3.47605 10.9549 2.29738 12.4589 3.06672C11.9655 4.65605 10.2815 5.21205 9.55619 6.61738C9.81485 8.08538 10.8655 9.40271 10.9975 11.0147C9.83883 11.7134 9.26151 10.7747 8.58418 10.3134C7.89085 9.84005 7.27217 9.25605 6.5415 8.65339C5.41884 9.56539 4.33617 10.4441 3.10951 11.4387C1.92284 9.60005 3.56017 8.15206 3.30417 6.54272C2.4535 5.55872 1.53884 4.50138 0.541504 3.34938C2.11484 2.30405 3.2655 3.62538 4.70016 3.46672C4.91483 2.97072 5.17885 2.34805 5.45485 1.73205C5.70552 1.17205 5.97085 0.617382 6.25752 4.82316e-05Z" fill="#AC8039"/>
        </svg>
        <hr class="flex-fill">
    </div>

    <div>
        <span class="label">Рекомендуем</span>
    </div>

    <div class="name wrap-anywhere">
        { record.name }
    </div>

    {#if (record.description)}
        <div class="description wrap-anywhere">
            { record.description }
        </div>
    {/if}


    {#if (record.prices?.length > 0 && record.prices[0]?.price !== null && record.prices[0]?.price !== undefined)}

        {#if (record.prices?.length === 1 && record.prices[0].weight)}
        <div class="weight nowrap">
            { record.prices[0].weight }
        </div>
        {/if}

        <div class="price nowrap flex gap-05 ai-center">

            {#if (record.prices[0].oldPrice !== undefined)}
                <span class="price--old">{ record.prices[0].oldPrice }</span>
            {/if}

            {#if (record.prices?.length > 1 || record.mods?.length > 0 )}
                <span>от </span>
            {/if}

            {#if (publishConfig?.currency)}
                <span class="nowrap"><span class="price">{ record.prices[0].price }</span>&nbsp;<span class="currency">{ publishConfig?.currency }</span></span>
            {:else}
                <span class="price">
                    { record.prices[0].price }
                </span>
            {/if}

            {#if (publishConfig.disableCart !== true)}
                <div class="order-buttons" class:order-buttons--added={(record?._orderedItems || 0) > 0}>
                    {#if ( (record?._orderedItems || 0) > 0)}
                        <button class="add-button pointer" on:click|stopPropagation={removeFromCartHandler(record)}>-</button>
                        <span>{record?._orderedItems}</span>
                    {/if}
                    <button class="add-button pointer" on:click|stopPropagation={addToCartHandler(record)}>+</button>
                </div>
            {/if}
        </div>

    {/if}

    {#if (!noBottomLine)}
    <hr class="full-width pt-05">
    {/if}

</div>
